<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Step size</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-line-chart
                  :height="250"
                  :data="ChartOptions.linearstepsizechart.data"
                  :options="ChartOptions.linearstepsizechart.options"
                ></chartjs-line-chart>
             </div>
        </div>
      </vs-col>
       <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Min Max</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-line-chart
                  :height="250"
                  :data="ChartOptions.linearminmaxchart.data"
                  :options="ChartOptions.linearminmaxchart.options"
                ></chartjs-line-chart>
             </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Min & max (suggested)</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-line-chart
                  :height="250"
                  :data="ChartOptions.linearminmaxsuggchart.data"
                  :options="ChartOptions.linearminmaxsuggchart.options"
                ></chartjs-line-chart>
             </div>
        </div>
      </vs-col>
     
       
    </div>
  </div>
</template>
<script>
import ChartjsLineChart from "../../components/chartjs/ChartjsLineChart.vue";
import ChartJS from "@/demo-data/Chart/Chartjs.js";

export default {
  components: {
   ChartjsLineChart
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      var keys = Object.keys(this.ChartOptions);

      for (var i = 0; i < keys.length; i++) {
        this.ChartOptions[keys[i]].options = {
          theme: {
            mode: mode,
          },
        };
      }
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
   ChartOptions: ChartJS[0],
    };
  },
};
</script>